"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ed5 = require("xmlchars/xml/1.0/ed5");
var ed2 = require("xmlchars/xml/1.1/ed2");
var NSed3 = require("xmlchars/xmlns/1.0/ed3");
var isS = ed5.isS;
var isChar10 = ed5.isChar;
var isNameStartChar = ed5.isNameStartChar;
var isNameChar = ed5.isNameChar;
var S_LIST = ed5.S_LIST;
var NAME_RE = ed5.NAME_RE;
var isChar11 = ed2.isChar;
var isNCNameStartChar = NSed3.isNCNameStartChar;
var isNCNameChar = NSed3.isNCNameChar;
var NC_NAME_RE = NSed3.NC_NAME_RE;
var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
var rootNS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  xml: XML_NAMESPACE,
  xmlns: XMLNS_NAMESPACE
};
var XML_ENTITIES = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  amp: "&",
  gt: ">",
  lt: "<",
  quot: "\"",
  apos: "'"
};
// EOC: end-of-chunk
var EOC = -1;
var NL_LIKE = -2;
var S_BEGIN = 0; // Initial state.
var S_BEGIN_WHITESPACE = 1; // leading whitespace
var S_DOCTYPE = 2; // <!DOCTYPE
var S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
var S_DTD = 4; // <!DOCTYPE "//blah" [ ...
var S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
var S_DTD_OPEN_WAKA = 6;
var S_DTD_OPEN_WAKA_BANG = 7;
var S_DTD_COMMENT = 8; // <!--
var S_DTD_COMMENT_ENDING = 9; // <!-- blah -
var S_DTD_COMMENT_ENDED = 10; // <!-- blah --
var S_DTD_PI = 11; // <?
var S_DTD_PI_ENDING = 12; // <?hi "there" ?
var S_TEXT = 13; // general stuff
var S_ENTITY = 14; // &amp and such
var S_OPEN_WAKA = 15; // <
var S_OPEN_WAKA_BANG = 16; // <!...
var S_COMMENT = 17; // <!--
var S_COMMENT_ENDING = 18; // <!-- blah -
var S_COMMENT_ENDED = 19; // <!-- blah --
var S_CDATA = 20; // <![CDATA[ something
var S_CDATA_ENDING = 21; // ]
var S_CDATA_ENDING_2 = 22; // ]]
var S_PI_FIRST_CHAR = 23; // <?hi, first char
var S_PI_REST = 24; // <?hi, rest of the name
var S_PI_BODY = 25; // <?hi there
var S_PI_ENDING = 26; // <?hi "there" ?
var S_XML_DECL_NAME_START = 27; // <?xml
var S_XML_DECL_NAME = 28; // <?xml foo
var S_XML_DECL_EQ = 29; // <?xml foo=
var S_XML_DECL_VALUE_START = 30; // <?xml foo=
var S_XML_DECL_VALUE = 31; // <?xml foo="bar"
var S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
var S_XML_DECL_ENDING = 33; // <?xml ... ?
var S_OPEN_TAG = 34; // <strong
var S_OPEN_TAG_SLASH = 35; // <strong /
var S_ATTRIB = 36; // <a
var S_ATTRIB_NAME = 37; // <a foo
var S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
var S_ATTRIB_VALUE = 39; // <a foo=
var S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
var S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
var S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
var S_CLOSE_TAG = 43; // </a
var S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
var BANG = 0x21;
var DQUOTE = 0x22;
var AMP = 0x26;
var SQUOTE = 0x27;
var MINUS = 0x2D;
var FORWARD_SLASH = 0x2F;
var SEMICOLON = 0x3B;
var LESS = 0x3C;
var EQUAL = 0x3D;
var GREATER = 0x3E;
var QUESTION = 0x3F;
var OPEN_BRACKET = 0x5B;
var CLOSE_BRACKET = 0x5D;
var NEL = 0x85;
var LS = 0x2028; // Line Separator
var isQuote = function isQuote(c) {
  return c === DQUOTE || c === SQUOTE;
};
var QUOTES = [DQUOTE, SQUOTE];
var DOCTYPE_TERMINATOR = [].concat(QUOTES, [OPEN_BRACKET, GREATER]);
var DTD_TERMINATOR = [].concat(QUOTES, [LESS, CLOSE_BRACKET]);
var XML_DECL_NAME_TERMINATOR = [EQUAL, QUESTION].concat(_toConsumableArray(S_LIST));
var ATTRIB_VALUE_UNQUOTED_TERMINATOR = [].concat(_toConsumableArray(S_LIST), [GREATER, AMP, LESS]);
function nsPairCheck(parser, prefix, uri) {
  switch (prefix) {
    case "xml":
      if (uri !== XML_NAMESPACE) {
        parser.fail("xml prefix must be bound to ".concat(XML_NAMESPACE, "."));
      }
      break;
    case "xmlns":
      if (uri !== XMLNS_NAMESPACE) {
        parser.fail("xmlns prefix must be bound to ".concat(XMLNS_NAMESPACE, "."));
      }
      break;
    default:
  }
  switch (uri) {
    case XMLNS_NAMESPACE:
      parser.fail(prefix === "" ? "the default namespace may not be set to ".concat(uri, ".") : "may not assign a prefix (even \"xmlns\") to the URI ".concat(XMLNS_NAMESPACE, "."));
      break;
    case XML_NAMESPACE:
      switch (prefix) {
        case "xml":
          // Assinging the XML namespace to "xml" is fine.
          break;
        case "":
          parser.fail("the default namespace may not be set to ".concat(uri, "."));
          break;
        default:
          parser.fail("may not assign the xml namespace to another prefix.");
      }
      break;
    default:
  }
}
function nsMappingCheck(parser, mapping) {
  for (var _i = 0, _Object$keys = Object.keys(mapping); _i < _Object$keys.length; _i++) {
    var local = _Object$keys[_i];
    nsPairCheck(parser, local, mapping[local]);
  }
}
var isNCName = function isNCName(name) {
  return NC_NAME_RE.test(name);
};
var isName = function isName(name) {
  return NAME_RE.test(name);
};
var FORBIDDEN_START = 0;
var FORBIDDEN_BRACKET = 1;
var FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */
exports.EVENTS = ["xmldecl", "text", "processinginstruction", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "cdata", "error", "end", "ready"];
var EVENT_NAME_TO_HANDLER_NAME = {
  xmldecl: "xmldeclHandler",
  text: "textHandler",
  processinginstruction: "piHandler",
  doctype: "doctypeHandler",
  comment: "commentHandler",
  opentagstart: "openTagStartHandler",
  attribute: "attributeHandler",
  opentag: "openTagHandler",
  closetag: "closeTagHandler",
  cdata: "cdataHandler",
  error: "errorHandler",
  end: "endHandler",
  ready: "readyHandler"
};
var SaxesParser = /*#__PURE__*/function () {
  /**
   * @param opt The parser options.
   */
  function SaxesParser(opt) {
    _classCallCheck(this, SaxesParser);
    this.opt = opt !== null && opt !== void 0 ? opt : {};
    this.fragmentOpt = !!this.opt.fragment;
    var xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
    this.trackPosition = this.opt.position !== false;
    this.fileName = this.opt.fileName;
    if (xmlnsOpt) {
      // This is the function we use to perform name checks on PIs and entities.
      // When namespaces are used, colons are not allowed in PI target names or
      // entity names. So the check depends on whether namespaces are used. See:
      //
      // https://www.w3.org/XML/xml-names-19990114-errata.html
      // NE08
      //
      this.nameStartCheck = isNCNameStartChar;
      this.nameCheck = isNCNameChar;
      this.isName = isNCName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsNS;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribNS;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.ns = Object.assign({
        __proto__: null
      }, rootNS);
      var additional = this.opt.additionalNamespaces;
      if (additional != null) {
        nsMappingCheck(this, additional);
        Object.assign(this.ns, additional);
      }
    } else {
      this.nameStartCheck = isNameStartChar;
      this.nameCheck = isNameChar;
      this.isName = isName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsPlain;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribPlain;
    }
    //
    // The order of the members in this table needs to correspond to the state
    // numbers given to the states that correspond to the methods being recorded
    // here.
    //
    this.stateTable = [/* eslint-disable @typescript-eslint/unbound-method */
    this.sBegin, this.sBeginWhitespace, this.sDoctype, this.sDoctypeQuote, this.sDTD, this.sDTDQuoted, this.sDTDOpenWaka, this.sDTDOpenWakaBang, this.sDTDComment, this.sDTDCommentEnding, this.sDTDCommentEnded, this.sDTDPI, this.sDTDPIEnding, this.sText, this.sEntity, this.sOpenWaka, this.sOpenWakaBang, this.sComment, this.sCommentEnding, this.sCommentEnded, this.sCData, this.sCDataEnding, this.sCDataEnding2, this.sPIFirstChar, this.sPIRest, this.sPIBody, this.sPIEnding, this.sXMLDeclNameStart, this.sXMLDeclName, this.sXMLDeclEq, this.sXMLDeclValueStart, this.sXMLDeclValue, this.sXMLDeclSeparator, this.sXMLDeclEnding, this.sOpenTag, this.sOpenTagSlash, this.sAttrib, this.sAttribName, this.sAttribNameSawWhite, this.sAttribValue, this.sAttribValueQuoted, this.sAttribValueClosed, this.sAttribValueUnquoted, this.sCloseTag, this.sCloseTagSawWhite];
    this._init();
  }
  /**
   * Indicates whether or not the parser is closed. If ``true``, wait for
   * the ``ready`` event to write again.
   */
  _createClass(SaxesParser, [{
    key: "closed",
    get: function get() {
      return this._closed;
    }
  }, {
    key: "_init",
    value: function _init() {
      var _a;
      this.openWakaBang = "";
      this.text = "";
      this.name = "";
      this.piTarget = "";
      this.entity = "";
      this.q = null;
      this.tags = [];
      this.tag = null;
      this.topNS = null;
      this.chunk = "";
      this.chunkPosition = 0;
      this.i = 0;
      this.prevI = 0;
      this.carriedFromPrevious = undefined;
      this.forbiddenState = FORBIDDEN_START;
      this.attribList = [];
      // The logic is organized so as to minimize the need to check
      // this.opt.fragment while parsing.
      var fragmentOpt = this.fragmentOpt;
      this.state = fragmentOpt ? S_TEXT : S_BEGIN;
      // We want these to be all true if we are dealing with a fragment.
      this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
      // An XML declaration is intially possible only when parsing whole
      // documents.
      this.xmlDeclPossible = !fragmentOpt;
      this.xmlDeclExpects = ["version"];
      this.entityReturnState = undefined;
      var defaultXMLVersion = this.opt.defaultXMLVersion;
      if (defaultXMLVersion === undefined) {
        if (this.opt.forceXMLVersion === true) {
          throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
        }
        defaultXMLVersion = "1.0";
      }
      this.setXMLVersion(defaultXMLVersion);
      this.positionAtNewLine = 0;
      this.doctype = false;
      this._closed = false;
      this.xmlDecl = {
        version: undefined,
        encoding: undefined,
        standalone: undefined
      };
      this.line = 1;
      this.column = 0;
      this.ENTITIES = Object.create(XML_ENTITIES);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.readyHandler) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */
  }, {
    key: "position",
    get: function get() {
      return this.chunkPosition + this.i;
    }
    /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */
  }, {
    key: "columnIndex",
    get: function get() {
      return this.position - this.positionAtNewLine;
    }
    /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */
  }, {
    key: "on",
    value: function on(name, handler) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
    }
    /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */
  }, {
    key: "off",
    value: function off(name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
    }
    /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */
  }, {
    key: "makeError",
    value: function makeError(message) {
      var _a;
      var msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
      if (this.trackPosition) {
        if (msg.length > 0) {
          msg += ":";
        }
        msg += "".concat(this.line, ":").concat(this.column);
      }
      if (msg.length > 0) {
        msg += ": ";
      }
      return new Error(msg + message);
    }
    /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */
  }, {
    key: "fail",
    value: function fail(message) {
      var err = this.makeError(message);
      var handler = this.errorHandler;
      if (handler === undefined) {
        throw err;
      } else {
        handler(err);
      }
      return this;
    }
    /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */
  }, {
    key: "write",
    value: function write(chunk) {
      if (this.closed) {
        return this.fail("cannot write after close; assign an onready handler.");
      }
      var end = false;
      if (chunk === null) {
        // We cannot return immediately because carriedFromPrevious may need
        // processing.
        end = true;
        chunk = "";
      } else if (_typeof(chunk) === "object") {
        chunk = chunk.toString();
      }
      // We checked if performing a pre-decomposition of the string into an array
      // of single complete characters (``Array.from(chunk)``) would be faster
      // than the current repeated calls to ``charCodeAt``. As of August 2018, it
      // isn't. (There may be Node-specific code that would perform faster than
      // ``Array.from`` but don't want to be dependent on Node.)
      if (this.carriedFromPrevious !== undefined) {
        // The previous chunk had char we must carry over.
        chunk = "".concat(this.carriedFromPrevious).concat(chunk);
        this.carriedFromPrevious = undefined;
      }
      var limit = chunk.length;
      var lastCode = chunk.charCodeAt(limit - 1);
      if (!end && (
      // A trailing CR or surrogate must be carried over to the next
      // chunk.
      lastCode === CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
        // The chunk ends with a character that must be carried over. We cannot
        // know how to handle it until we get the next chunk or the end of the
        // stream. So save it for later.
        this.carriedFromPrevious = chunk[limit - 1];
        limit--;
        chunk = chunk.slice(0, limit);
      }
      var stateTable = this.stateTable;
      this.chunk = chunk;
      this.i = 0;
      while (this.i < limit) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        stateTable[this.state].call(this);
      }
      this.chunkPosition += limit;
      return end ? this.end() : this;
    }
    /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */
  }, {
    key: "close",
    value: function close() {
      return this.write(null);
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */
  }, {
    key: "getCode10",
    value: function getCode10() {
      var chunk = this.chunk,
        i = this.i;
      this.prevI = i;
      // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.
      this.i = i + 1;
      if (i >= chunk.length) {
        return EOC;
      }
      // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.
      var code = chunk.charCodeAt(i);
      this.column++;
      if (code < 0xD800) {
        if (code >= SPACE || code === TAB) {
          return code;
        }
        switch (code) {
          case NL:
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;
          case CR:
            // We may get NaN if we read past the end of the chunk, which is fine.
            if (chunk.charCodeAt(i + 1) === NL) {
              // A \r\n sequence is converted to \n so we have to skip over the
              // next character. We already know it has a size of 1 so ++ is fine
              // here.
              this.i = i + 2;
            }
            // Otherwise, a \r is just converted to \n, so we don't have to skip
            // ahead.
            // In either case, \r becomes \n.
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;
          default:
            // If we get here, then code < SPACE and it is not NL CR or TAB.
            this.fail("disallowed character.");
            return code;
        }
      }
      if (code > 0xDBFF) {
        // This is a specialized version of isChar10 that takes into account
        // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
        // test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }
        return code;
      }
      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2;
      // This is a specialized version of isChar10 that takes into account that in
      // this context necessarily final >= 0x10000.
      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }
      return final;
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */
  }, {
    key: "getCode11",
    value: function getCode11() {
      var chunk = this.chunk,
        i = this.i;
      this.prevI = i;
      // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.
      this.i = i + 1;
      if (i >= chunk.length) {
        return EOC;
      }
      // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.
      var code = chunk.charCodeAt(i);
      this.column++;
      if (code < 0xD800) {
        if (code > 0x1F && code < 0x7F || code > 0x9F && code !== LS || code === TAB) {
          return code;
        }
        switch (code) {
          case NL:
            // 0xA
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;
          case CR:
            {
              // 0xD
              // We may get NaN if we read past the end of the chunk, which is
              // fine.
              var next = chunk.charCodeAt(i + 1);
              if (next === NL || next === NEL) {
                // A CR NL or CR NEL sequence is converted to NL so we have to skip
                // over the next character. We already know it has a size of 1.
                this.i = i + 2;
              }
              // Otherwise, a CR is just converted to NL, no skip.
            }
          /* yes, fall through */
          case NEL: // 0x85
          case LS:
            // Ox2028
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;
          default:
            this.fail("disallowed character.");
            return code;
        }
      }
      if (code > 0xDBFF) {
        // This is a specialized version of isCharAndNotRestricted that takes into
        // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
        // does not test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }
        return code;
      }
      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2;
      // This is a specialized version of isCharAndNotRestricted that takes into
      // account that in this context necessarily final >= 0x10000.
      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }
      return final;
    }
    /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */
  }, {
    key: "getCodeNorm",
    value: function getCodeNorm() {
      var c = this.getCode();
      return c === NL_LIKE ? NL : c;
    }
  }, {
    key: "unget",
    value: function unget() {
      this.i = this.prevI;
      this.column--;
    }
    /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "captureTo",
    value: function captureTo(chars) {
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        var isNLLike = c === NL_LIKE;
        var final = isNLLike ? NL : c;
        if (final === EOC || chars.includes(final)) {
          this.text += chunk.slice(start, this.prevI);
          return final;
        }
        if (isNLLike) {
          this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          start = this.i;
        }
      }
    }
    /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */
  }, {
    key: "captureToChar",
    value: function captureToChar(char) {
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        switch (c) {
          case NL_LIKE:
            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            c = NL;
            break;
          case EOC:
            this.text += chunk.slice(start);
            return false;
          default:
        }
        if (c === char) {
          this.text += chunk.slice(start, this.prevI);
          return true;
        }
      }
    }
    /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "captureNameChars",
    value: function captureNameChars() {
      var chunk = this.chunk,
        start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCode();
        if (c === EOC) {
          this.name += chunk.slice(start);
          return EOC;
        }
        // NL is not a name char so we don't have to test specifically for it.
        if (!isNameChar(c)) {
          this.name += chunk.slice(start, this.prevI);
          return c === NL_LIKE ? NL : c;
        }
      }
    }
    /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */
  }, {
    key: "skipSpaces",
    value: function skipSpaces() {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();
        if (c === EOC || !isS(c)) {
          return c;
        }
      }
    }
  }, {
    key: "setXMLVersion",
    value: function setXMLVersion(version) {
      this.currentXMLVersion = version;
      /*  eslint-disable @typescript-eslint/unbound-method */
      if (version === "1.0") {
        this.isChar = isChar10;
        this.getCode = this.getCode10;
      } else {
        this.isChar = isChar11;
        this.getCode = this.getCode11;
      }
      /* eslint-enable @typescript-eslint/unbound-method */
    }
    // STATE ENGINE METHODS
    // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
    // to be sure never to come back to this state later.
  }, {
    key: "sBegin",
    value: function sBegin() {
      // We are essentially peeking at the first character of the chunk. Since
      // S_BEGIN can be in effect only when we start working on the first chunk,
      // the index at which we must look is necessarily 0. Note also that the
      // following test does not depend on decoding surrogates.
      // If the initial character is 0xFEFF, ignore it.
      if (this.chunk.charCodeAt(0) === 0xFEFF) {
        this.i++;
        this.column++;
      }
      this.state = S_BEGIN_WHITESPACE;
    }
  }, {
    key: "sBeginWhitespace",
    value: function sBeginWhitespace() {
      // We need to know whether we've encountered spaces or not because as soon
      // as we run into a space, an XML declaration is no longer possible. Rather
      // than slow down skipSpaces even in places where we don't care whether it
      // skipped anything or not, we check whether prevI is equal to the value of
      // i from before we skip spaces.
      var iBefore = this.i;
      var c = this.skipSpaces();
      if (this.prevI !== iBefore) {
        this.xmlDeclPossible = false;
      }
      switch (c) {
        case LESS:
          this.state = S_OPEN_WAKA;
          // We could naively call closeText but in this state, it is not normal
          // to have text be filled with any data.
          if (this.text.length !== 0) {
            throw new Error("no-empty text at start");
          }
          break;
        case EOC:
          break;
        default:
          this.unget();
          this.state = S_TEXT;
          this.xmlDeclPossible = false;
      }
    }
  }, {
    key: "sDoctype",
    value: function sDoctype() {
      var _a;
      var c = this.captureTo(DOCTYPE_TERMINATOR);
      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.doctypeHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            this.doctype = true; // just remember that we saw it.
            break;
          }
        case EOC:
          break;
        default:
          this.text += String.fromCodePoint(c);
          if (c === OPEN_BRACKET) {
            this.state = S_DTD;
          } else if (isQuote(c)) {
            this.state = S_DOCTYPE_QUOTE;
            this.q = c;
          }
      }
    }
  }, {
    key: "sDoctypeQuote",
    value: function sDoctypeQuote() {
      var q = this.q;
      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.q = null;
        this.state = S_DOCTYPE;
      }
    }
  }, {
    key: "sDTD",
    value: function sDTD() {
      var c = this.captureTo(DTD_TERMINATOR);
      if (c === EOC) {
        return;
      }
      this.text += String.fromCodePoint(c);
      if (c === CLOSE_BRACKET) {
        this.state = S_DOCTYPE;
      } else if (c === LESS) {
        this.state = S_DTD_OPEN_WAKA;
      } else if (isQuote(c)) {
        this.state = S_DTD_QUOTED;
        this.q = c;
      }
    }
  }, {
    key: "sDTDQuoted",
    value: function sDTDQuoted() {
      var q = this.q;
      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.state = S_DTD;
        this.q = null;
      }
    }
  }, {
    key: "sDTDOpenWaka",
    value: function sDTDOpenWaka() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      switch (c) {
        case BANG:
          this.state = S_DTD_OPEN_WAKA_BANG;
          this.openWakaBang = "";
          break;
        case QUESTION:
          this.state = S_DTD_PI;
          break;
        default:
          this.state = S_DTD;
      }
    }
  }, {
    key: "sDTDOpenWakaBang",
    value: function sDTDOpenWakaBang() {
      var char = String.fromCodePoint(this.getCodeNorm());
      var owb = this.openWakaBang += char;
      this.text += char;
      if (owb !== "-") {
        this.state = owb === "--" ? S_DTD_COMMENT : S_DTD;
        this.openWakaBang = "";
      }
    }
  }, {
    key: "sDTDComment",
    value: function sDTDComment() {
      if (this.captureToChar(MINUS)) {
        this.text += "-";
        this.state = S_DTD_COMMENT_ENDING;
      }
    }
  }, {
    key: "sDTDCommentEnding",
    value: function sDTDCommentEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      this.state = c === MINUS ? S_DTD_COMMENT_ENDED : S_DTD_COMMENT;
    }
  }, {
    key: "sDTDCommentEnded",
    value: function sDTDCommentEnded() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      if (c === GREATER) {
        this.state = S_DTD;
      } else {
        this.fail("malformed comment.");
        // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "
        this.state = S_DTD_COMMENT;
      }
    }
  }, {
    key: "sDTDPI",
    value: function sDTDPI() {
      if (this.captureToChar(QUESTION)) {
        this.text += "?";
        this.state = S_DTD_PI_ENDING;
      }
    }
  }, {
    key: "sDTDPIEnding",
    value: function sDTDPIEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      if (c === GREATER) {
        this.state = S_DTD;
      }
    }
  }, {
    key: "sText",
    value: function sText() {
      //
      // We did try a version of saxes where the S_TEXT state was split in two
      // states: one for text inside the root element, and one for text
      // outside. This was avoiding having to test this.tags.length to decide
      // what implementation to actually use.
      //
      // Peformance testing on gigabyte-size files did not show any advantage to
      // using the two states solution instead of the current one. Conversely, it
      // made the code a bit more complicated elsewhere. For instance, a comment
      // can appear before the root element so when a comment ended it was
      // necessary to determine whether to return to the S_TEXT state or to the
      // new text-outside-root state.
      //
      if (this.tags.length !== 0) {
        this.handleTextInRoot();
      } else {
        this.handleTextOutsideRoot();
      }
    }
  }, {
    key: "sEntity",
    value: function sEntity() {
      // This is essentially a specialized version of captureToChar(SEMICOLON...)
      var start = this.i;
      var chunk = this.chunk;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      loop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case NL_LIKE:
            this.entity += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            break;
          case SEMICOLON:
            {
              var entityReturnState = this.entityReturnState;
              var entity = this.entity + chunk.slice(start, this.prevI);
              this.state = entityReturnState;
              var parsed = void 0;
              if (entity === "") {
                this.fail("empty entity name.");
                parsed = "&;";
              } else {
                parsed = this.parseEntity(entity);
                this.entity = "";
              }
              if (entityReturnState !== S_TEXT || this.textHandler !== undefined) {
                this.text += parsed;
              }
              // eslint-disable-next-line no-labels
              break loop;
            }
          case EOC:
            this.entity += chunk.slice(start);
            // eslint-disable-next-line no-labels
            break loop;
          default:
        }
      }
    }
  }, {
    key: "sOpenWaka",
    value: function sOpenWaka() {
      // Reminder: a state handler is called with at least one character
      // available in the current chunk. So the first call to get code inside of
      // a state handler cannot return ``EOC``. That's why we don't test
      // for it.
      var c = this.getCode();
      // either a /, ?, !, or text is coming next.
      if (isNameStartChar(c)) {
        this.state = S_OPEN_TAG;
        this.unget();
        this.xmlDeclPossible = false;
      } else {
        switch (c) {
          case FORWARD_SLASH:
            this.state = S_CLOSE_TAG;
            this.xmlDeclPossible = false;
            break;
          case BANG:
            this.state = S_OPEN_WAKA_BANG;
            this.openWakaBang = "";
            this.xmlDeclPossible = false;
            break;
          case QUESTION:
            this.state = S_PI_FIRST_CHAR;
            break;
          default:
            this.fail("disallowed character in tag name");
            this.state = S_TEXT;
            this.xmlDeclPossible = false;
        }
      }
    }
  }, {
    key: "sOpenWakaBang",
    value: function sOpenWakaBang() {
      this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
      switch (this.openWakaBang) {
        case "[CDATA[":
          if (!this.sawRoot && !this.reportedTextBeforeRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextBeforeRoot = true;
          }
          if (this.closedRoot && !this.reportedTextAfterRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextAfterRoot = true;
          }
          this.state = S_CDATA;
          this.openWakaBang = "";
          break;
        case "--":
          this.state = S_COMMENT;
          this.openWakaBang = "";
          break;
        case "DOCTYPE":
          this.state = S_DOCTYPE;
          if (this.doctype || this.sawRoot) {
            this.fail("inappropriately located doctype declaration.");
          }
          this.openWakaBang = "";
          break;
        default:
          // 7 happens to be the maximum length of the string that can possibly
          // match one of the cases above.
          if (this.openWakaBang.length >= 7) {
            this.fail("incorrect syntax.");
          }
      }
    }
  }, {
    key: "sComment",
    value: function sComment() {
      if (this.captureToChar(MINUS)) {
        this.state = S_COMMENT_ENDING;
      }
    }
  }, {
    key: "sCommentEnding",
    value: function sCommentEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === MINUS) {
        this.state = S_COMMENT_ENDED;
        // eslint-disable-next-line no-unused-expressions
        (_a = this.commentHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
        this.text = "";
      } else {
        this.text += "-".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      }
    }
  }, {
    key: "sCommentEnded",
    value: function sCommentEnded() {
      var c = this.getCodeNorm();
      if (c !== GREATER) {
        this.fail("malformed comment.");
        // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "
        this.text += "--".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      } else {
        this.state = S_TEXT;
      }
    }
  }, {
    key: "sCData",
    value: function sCData() {
      if (this.captureToChar(CLOSE_BRACKET)) {
        this.state = S_CDATA_ENDING;
      }
    }
  }, {
    key: "sCDataEnding",
    value: function sCDataEnding() {
      var c = this.getCodeNorm();
      if (c === CLOSE_BRACKET) {
        this.state = S_CDATA_ENDING_2;
      } else {
        this.text += "]".concat(String.fromCodePoint(c));
        this.state = S_CDATA;
      }
    }
  }, {
    key: "sCDataEnding2",
    value: function sCDataEnding2() {
      var _a;
      var c = this.getCodeNorm();
      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.cdataHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            break;
          }
        case CLOSE_BRACKET:
          this.text += "]";
          break;
        default:
          this.text += "]]".concat(String.fromCodePoint(c));
          this.state = S_CDATA;
      }
    }
    // We need this separate state to check the first character fo the pi target
    // with this.nameStartCheck which allows less characters than this.nameCheck.
  }, {
    key: "sPIFirstChar",
    value: function sPIFirstChar() {
      var c = this.getCodeNorm();
      // This is first because in the case where the file is well-formed this is
      // the branch taken. We optimize for well-formedness.
      if (this.nameStartCheck(c)) {
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      } else if (c === QUESTION || isS(c)) {
        this.fail("processing instruction without a target.");
        this.state = c === QUESTION ? S_PI_ENDING : S_PI_BODY;
      } else {
        this.fail("disallowed character in processing instruction name.");
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      }
    }
  }, {
    key: "sPIRest",
    value: function sPIRest() {
      // Capture characters into a piTarget while ``this.nameCheck`` run on the
      // character read returns true.
      var chunk = this.chunk,
        start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();
        if (c === EOC) {
          this.piTarget += chunk.slice(start);
          return;
        }
        // NL cannot satisfy this.nameCheck so we don't have to test specifically
        // for it.
        if (!this.nameCheck(c)) {
          this.piTarget += chunk.slice(start, this.prevI);
          var isQuestion = c === QUESTION;
          if (isQuestion || isS(c)) {
            if (this.piTarget === "xml") {
              if (!this.xmlDeclPossible) {
                this.fail("an XML declaration must be at the start of the document.");
              }
              this.state = isQuestion ? S_XML_DECL_ENDING : S_XML_DECL_NAME_START;
            } else {
              this.state = isQuestion ? S_PI_ENDING : S_PI_BODY;
            }
          } else {
            this.fail("disallowed character in processing instruction name.");
            this.piTarget += String.fromCodePoint(c);
          }
          break;
        }
      }
    }
  }, {
    key: "sPIBody",
    value: function sPIBody() {
      if (this.text.length === 0) {
        var c = this.getCodeNorm();
        if (c === QUESTION) {
          this.state = S_PI_ENDING;
        } else if (!isS(c)) {
          this.text = String.fromCodePoint(c);
        }
      }
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      else if (this.captureToChar(QUESTION)) {
        this.state = S_PI_ENDING;
      }
    }
  }, {
    key: "sPIEnding",
    value: function sPIEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === GREATER) {
        var piTarget = this.piTarget;
        if (piTarget.toLowerCase() === "xml") {
          this.fail("the XML declaration must appear at the start of the document.");
        }
        // eslint-disable-next-line no-unused-expressions
        (_a = this.piHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
          target: piTarget,
          body: this.text
        });
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else if (c === QUESTION) {
        // We ran into ?? as part of a processing instruction. We initially took
        // the first ? as a sign that the PI was ending, but it is not. So we have
        // to add it to the body but we take the new ? as a sign that the PI is
        // ending.
        this.text += "?";
      } else {
        this.text += "?".concat(String.fromCodePoint(c));
        this.state = S_PI_BODY;
      }
      this.xmlDeclPossible = false;
    }
  }, {
    key: "sXMLDeclNameStart",
    value: function sXMLDeclNameStart() {
      var c = this.skipSpaces();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }
      if (c !== EOC) {
        this.state = S_XML_DECL_NAME;
        this.name = String.fromCodePoint(c);
      }
    }
  }, {
    key: "sXMLDeclName",
    value: function sXMLDeclName() {
      var c = this.captureTo(XML_DECL_NAME_TERMINATOR);
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.name += this.text;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (!(isS(c) || c === EQUAL)) {
        return;
      }
      this.name += this.text;
      this.text = "";
      if (!this.xmlDeclExpects.includes(this.name)) {
        switch (this.name.length) {
          case 0:
            this.fail("did not expect any more name/value pairs.");
            break;
          case 1:
            this.fail("expected the name ".concat(this.xmlDeclExpects[0], "."));
            break;
          default:
            this.fail("expected one of ".concat(this.xmlDeclExpects.join(", ")));
        }
      }
      this.state = c === EQUAL ? S_XML_DECL_VALUE_START : S_XML_DECL_EQ;
    }
  }, {
    key: "sXMLDeclEq",
    value: function sXMLDeclEq() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (isS(c)) {
        return;
      }
      if (c !== EQUAL) {
        this.fail("value required.");
      }
      this.state = S_XML_DECL_VALUE_START;
    }
  }, {
    key: "sXMLDeclValueStart",
    value: function sXMLDeclValueStart() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (isS(c)) {
        return;
      }
      if (!isQuote(c)) {
        this.fail("value must be quoted.");
        this.q = SPACE;
      } else {
        this.q = c;
      }
      this.state = S_XML_DECL_VALUE;
    }
  }, {
    key: "sXMLDeclValue",
    value: function sXMLDeclValue() {
      var c = this.captureTo([this.q, QUESTION]);
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }
      if (c === EOC) {
        return;
      }
      var value = this.text;
      this.text = "";
      switch (this.name) {
        case "version":
          {
            this.xmlDeclExpects = ["encoding", "standalone"];
            var version = value;
            this.xmlDecl.version = version;
            // This is the test specified by XML 1.0 but it is fine for XML 1.1.
            if (!/^1\.[0-9]+$/.test(version)) {
              this.fail("version number must match /^1\\.[0-9]+$/.");
            }
            // When forceXMLVersion is set, the XML declaration is ignored.
            else if (!this.opt.forceXMLVersion) {
              this.setXMLVersion(version);
            }
            break;
          }
        case "encoding":
          if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) {
            this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
          }
          this.xmlDeclExpects = ["standalone"];
          this.xmlDecl.encoding = value;
          break;
        case "standalone":
          if (value !== "yes" && value !== "no") {
            this.fail("standalone value must match \"yes\" or \"no\".");
          }
          this.xmlDeclExpects = [];
          this.xmlDecl.standalone = value;
          break;
        default:
        // We don't need to raise an error here since we've already raised one
        // when checking what name was expected.
      }

      this.name = "";
      this.state = S_XML_DECL_SEPARATOR;
    }
  }, {
    key: "sXMLDeclSeparator",
    value: function sXMLDeclSeparator() {
      var c = this.getCodeNorm();
      // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }
      if (!isS(c)) {
        this.fail("whitespace required.");
        this.unget();
      }
      this.state = S_XML_DECL_NAME_START;
    }
  }, {
    key: "sXMLDeclEnding",
    value: function sXMLDeclEnding() {
      var _a;
      var c = this.getCodeNorm();
      if (c === GREATER) {
        if (this.piTarget !== "xml") {
          this.fail("processing instructions are not allowed before root.");
        } else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) {
          this.fail("XML declaration must contain a version.");
        }
        // eslint-disable-next-line no-unused-expressions
        (_a = this.xmldeclHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.xmlDecl);
        this.name = "";
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else {
        // We got here because the previous character was a ?, but the question
        // mark character is not valid inside any of the XML declaration
        // name/value pairs.
        this.fail("The character ? is disallowed anywhere in XML declarations.");
      }
      this.xmlDeclPossible = false;
    }
  }, {
    key: "sOpenTag",
    value: function sOpenTag() {
      var _a;
      var c = this.captureNameChars();
      if (c === EOC) {
        return;
      }
      var tag = this.tag = {
        name: this.name,
        attributes: Object.create(null)
      };
      this.name = "";
      if (this.xmlnsOpt) {
        this.topNS = tag.ns = Object.create(null);
      }
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagStartHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      this.sawRoot = true;
      if (!this.fragmentOpt && this.closedRoot) {
        this.fail("documents may contain only one root.");
      }
      switch (c) {
        case GREATER:
          this.openTag();
          break;
        case FORWARD_SLASH:
          this.state = S_OPEN_TAG_SLASH;
          break;
        default:
          if (!isS(c)) {
            this.fail("disallowed character in tag name.");
          }
          this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sOpenTagSlash",
    value: function sOpenTagSlash() {
      if (this.getCode() === GREATER) {
        this.openSelfClosingTag();
      } else {
        this.fail("forward-slash in opening tag not followed by >.");
        this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sAttrib",
    value: function sAttrib() {
      var c = this.skipSpaces();
      if (c === EOC) {
        return;
      }
      if (isNameStartChar(c)) {
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribName",
    value: function sAttribName() {
      var c = this.captureNameChars();
      if (c === EQUAL) {
        this.state = S_ATTRIB_VALUE;
      } else if (isS(c)) {
        this.state = S_ATTRIB_NAME_SAW_WHITE;
      } else if (c === GREATER) {
        this.fail("attribute without value.");
        this.pushAttrib(this.name, this.name);
        this.name = this.text = "";
        this.openTag();
      } else if (c !== EOC) {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribNameSawWhite",
    value: function sAttribNameSawWhite() {
      var c = this.skipSpaces();
      switch (c) {
        case EOC:
          return;
        case EQUAL:
          this.state = S_ATTRIB_VALUE;
          break;
        default:
          this.fail("attribute without value.");
          // Should we do this???
          // this.tag.attributes[this.name] = "";
          this.text = "";
          this.name = "";
          if (c === GREATER) {
            this.openTag();
          } else if (isNameStartChar(c)) {
            this.unget();
            this.state = S_ATTRIB_NAME;
          } else {
            this.fail("disallowed character in attribute name.");
            this.state = S_ATTRIB;
          }
      }
    }
  }, {
    key: "sAttribValue",
    value: function sAttribValue() {
      var c = this.getCodeNorm();
      if (isQuote(c)) {
        this.q = c;
        this.state = S_ATTRIB_VALUE_QUOTED;
      } else if (!isS(c)) {
        this.fail("unquoted attribute value.");
        this.state = S_ATTRIB_VALUE_UNQUOTED;
        this.unget();
      }
    }
  }, {
    key: "sAttribValueQuoted",
    value: function sAttribValueQuoted() {
      // We deliberately do not use captureTo here. The specialized code we use
      // here is faster than using captureTo.
      var q = this.q,
        chunk = this.chunk;
      var start = this.i;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case q:
            this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
            this.name = this.text = "";
            this.q = null;
            this.state = S_ATTRIB_VALUE_CLOSED;
            return;
          case AMP:
            this.text += chunk.slice(start, this.prevI);
            this.state = S_ENTITY;
            this.entityReturnState = S_ATTRIB_VALUE_QUOTED;
            return;
          case NL:
          case NL_LIKE:
          case TAB:
            this.text += "".concat(chunk.slice(start, this.prevI), " ");
            start = this.i;
            break;
          case LESS:
            this.text += chunk.slice(start, this.prevI);
            this.fail("disallowed character.");
            return;
          case EOC:
            this.text += chunk.slice(start);
            return;
          default:
        }
      }
    }
  }, {
    key: "sAttribValueClosed",
    value: function sAttribValueClosed() {
      var c = this.getCodeNorm();
      if (isS(c)) {
        this.state = S_ATTRIB;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else if (isNameStartChar(c)) {
        this.fail("no whitespace between attributes.");
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribValueUnquoted",
    value: function sAttribValueUnquoted() {
      // We don't do anything regarding EOL or space handling for unquoted
      // attributes. We already have failed by the time we get here, and the
      // contract that saxes upholds states that upon failure, it is not safe to
      // rely on the data passed to event handlers (other than
      // ``onerror``). Passing "bad" data is not a problem.
      var c = this.captureTo(ATTRIB_VALUE_UNQUOTED_TERMINATOR);
      switch (c) {
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_ATTRIB_VALUE_UNQUOTED;
          break;
        case LESS:
          this.fail("disallowed character.");
          break;
        case EOC:
          break;
        default:
          if (this.text.includes("]]>")) {
            this.fail("the string \"]]>\" is disallowed in char data.");
          }
          this.pushAttrib(this.name, this.text);
          this.name = this.text = "";
          if (c === GREATER) {
            this.openTag();
          } else {
            this.state = S_ATTRIB;
          }
      }
    }
  }, {
    key: "sCloseTag",
    value: function sCloseTag() {
      var c = this.captureNameChars();
      if (c === GREATER) {
        this.closeTag();
      } else if (isS(c)) {
        this.state = S_CLOSE_TAG_SAW_WHITE;
      } else if (c !== EOC) {
        this.fail("disallowed character in closing tag.");
      }
    }
  }, {
    key: "sCloseTagSawWhite",
    value: function sCloseTagSawWhite() {
      switch (this.skipSpaces()) {
        case GREATER:
          this.closeTag();
          break;
        case EOC:
          break;
        default:
          this.fail("disallowed character in closing tag.");
      }
    }
    // END OF STATE ENGINE METHODS
  }, {
    key: "handleTextInRoot",
    value: function handleTextInRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for performing the ]]> check. A previous version of this code, checked
      // ``this.text`` for the presence of ]]>. It simplified the code but was
      // very costly when character data contained a lot of entities to be parsed.
      //
      // Since we are using a specialized loop, we also keep track of the presence
      // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
      //
      var start = this.i,
        forbiddenState = this.forbiddenState;
      var chunk = this.chunk,
        handler = this.textHandler;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      scanLoop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;
              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);
                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }
              forbiddenState = FORBIDDEN_START;
              // eslint-disable-next-line no-labels
              break scanLoop;
            }
          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;
            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }
            forbiddenState = FORBIDDEN_START;
            // eslint-disable-next-line no-labels
            break scanLoop;
          case CLOSE_BRACKET:
            switch (forbiddenState) {
              case FORBIDDEN_START:
                forbiddenState = FORBIDDEN_BRACKET;
                break;
              case FORBIDDEN_BRACKET:
                forbiddenState = FORBIDDEN_BRACKET_BRACKET;
                break;
              case FORBIDDEN_BRACKET_BRACKET:
                break;
              default:
                throw new Error("impossible state");
            }
            break;
          case GREATER:
            if (forbiddenState === FORBIDDEN_BRACKET_BRACKET) {
              this.fail("the string \"]]>\" is disallowed in char data.");
            }
            forbiddenState = FORBIDDEN_START;
            break;
          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }
            start = this.i;
            forbiddenState = FORBIDDEN_START;
            break;
          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            }
            // eslint-disable-next-line no-labels
            break scanLoop;
          default:
            forbiddenState = FORBIDDEN_START;
        }
      }
      this.forbiddenState = forbiddenState;
    }
  }, {
    key: "handleTextOutsideRoot",
    value: function handleTextOutsideRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for a specialized task. We keep track of the presence of non-space
      // characters in the text since these are errors when appearing outside the
      // document root element.
      var start = this.i;
      var chunk = this.chunk,
        handler = this.textHandler;
      var nonSpace = false;
      // eslint-disable-next-line no-labels, no-restricted-syntax
      outRootLoop:
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var code = this.getCode();
        switch (code) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;
              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);
                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }
              // eslint-disable-next-line no-labels
              break outRootLoop;
            }
          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;
            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }
            nonSpace = true;
            // eslint-disable-next-line no-labels
            break outRootLoop;
          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }
            start = this.i;
            break;
          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            }
            // eslint-disable-next-line no-labels
            break outRootLoop;
          default:
            if (!isS(code)) {
              nonSpace = true;
            }
        }
      }
      if (!nonSpace) {
        return;
      }
      // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
      // to avoid reporting errors for every single character that is out of
      // place.
      if (!this.sawRoot && !this.reportedTextBeforeRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextBeforeRoot = true;
      }
      if (this.closedRoot && !this.reportedTextAfterRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextAfterRoot = true;
      }
    }
  }, {
    key: "pushAttribNS",
    value: function pushAttribNS(name, value) {
      var _a;
      var _this$qname = this.qname(name),
        prefix = _this$qname.prefix,
        local = _this$qname.local;
      var attr = {
        name: name,
        prefix: prefix,
        local: local,
        value: value
      };
      this.attribList.push(attr);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
      if (prefix === "xmlns") {
        var trimmed = value.trim();
        if (this.currentXMLVersion === "1.0" && trimmed === "") {
          this.fail("invalid attempt to undefine prefix in XML 1.0");
        }
        this.topNS[local] = trimmed;
        nsPairCheck(this, local, trimmed);
      } else if (name === "xmlns") {
        var _trimmed = value.trim();
        this.topNS[""] = _trimmed;
        nsPairCheck(this, "", _trimmed);
      }
    }
  }, {
    key: "pushAttribPlain",
    value: function pushAttribPlain(name, value) {
      var _a;
      var attr = {
        name: name,
        value: value
      };
      this.attribList.push(attr);
      // eslint-disable-next-line no-unused-expressions
      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
    }
    /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */
  }, {
    key: "end",
    value: function end() {
      var _a, _b;
      if (!this.sawRoot) {
        this.fail("document must contain a root element.");
      }
      var tags = this.tags;
      while (tags.length > 0) {
        var tag = tags.pop();
        this.fail("unclosed tag: ".concat(tag.name));
      }
      if (this.state !== S_BEGIN && this.state !== S_TEXT) {
        this.fail("unexpected end.");
      }
      var text = this.text;
      if (text.length !== 0) {
        // eslint-disable-next-line no-unused-expressions
        (_a = this.textHandler) === null || _a === void 0 ? void 0 : _a.call(this, text);
        this.text = "";
      }
      this._closed = true;
      // eslint-disable-next-line no-unused-expressions
      (_b = this.endHandler) === null || _b === void 0 ? void 0 : _b.call(this);
      this._init();
      return this;
    }
    /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */
  }, {
    key: "resolve",
    value: function resolve(prefix) {
      var _a, _b;
      var uri = this.topNS[prefix];
      if (uri !== undefined) {
        return uri;
      }
      var tags = this.tags;
      for (var index = tags.length - 1; index >= 0; index--) {
        uri = tags[index].ns[prefix];
        if (uri !== undefined) {
          return uri;
        }
      }
      uri = this.ns[prefix];
      if (uri !== undefined) {
        return uri;
      }
      return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
    }
    /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */
  }, {
    key: "qname",
    value: function qname(name) {
      // This is faster than using name.split(":").
      var colon = name.indexOf(":");
      if (colon === -1) {
        return {
          prefix: "",
          local: name
        };
      }
      var local = name.slice(colon + 1);
      var prefix = name.slice(0, colon);
      if (prefix === "" || local === "" || local.includes(":")) {
        this.fail("malformed name: ".concat(name, "."));
      }
      return {
        prefix: prefix,
        local: local
      };
    }
  }, {
    key: "processAttribsNS",
    value: function processAttribsNS() {
      var _a;
      var attribList = this.attribList;
      var tag = this.tag;
      {
        // add namespace info to tag
        var _this$qname2 = this.qname(tag.name),
          prefix = _this$qname2.prefix,
          local = _this$qname2.local;
        tag.prefix = prefix;
        tag.local = local;
        var uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
        if (prefix !== "") {
          if (prefix === "xmlns") {
            this.fail("tags may not have \"xmlns\" as prefix.");
          }
          if (uri === "") {
            this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
            tag.uri = prefix;
          }
        }
      }
      if (attribList.length === 0) {
        return;
      }
      var attributes = tag.attributes;
      var seen = new Set();
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      var _iterator = _createForOfIteratorHelper(attribList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          var name = attr.name,
            _prefix = attr.prefix,
            _local = attr.local;
          var _uri = void 0;
          var eqname = void 0;
          if (_prefix === "") {
            _uri = name === "xmlns" ? XMLNS_NAMESPACE : "";
            eqname = name;
          } else {
            _uri = this.resolve(_prefix);
            // if there's any attributes with an undefined namespace,
            // then fail on them now.
            if (_uri === undefined) {
              this.fail("unbound namespace prefix: ".concat(JSON.stringify(_prefix), "."));
              _uri = _prefix;
            }
            eqname = "{".concat(_uri, "}").concat(_local);
          }
          if (seen.has(eqname)) {
            this.fail("duplicate attribute: ".concat(eqname, "."));
          }
          seen.add(eqname);
          attr.uri = _uri;
          attributes[name] = attr;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.attribList = [];
    }
  }, {
    key: "processAttribsPlain",
    value: function processAttribsPlain() {
      var attribList = this.attribList;
      // eslint-disable-next-line prefer-destructuring
      var attributes = this.tag.attributes;
      var _iterator2 = _createForOfIteratorHelper(attribList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
            name = _step2$value.name,
            value = _step2$value.value;
          if (attributes[name] !== undefined) {
            this.fail("duplicate attribute: ".concat(name, "."));
          }
          attributes[name] = value;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.attribList = [];
    }
    /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */
  }, {
    key: "openTag",
    value: function openTag() {
      var _a;
      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = false;
      // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      tags.push(tag);
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */
  }, {
    key: "openSelfClosingTag",
    value: function openSelfClosingTag() {
      var _a, _b, _c;
      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = true;
      // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions
      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      // eslint-disable-next-line no-unused-expressions
      (_b = this.closeTagHandler) === null || _b === void 0 ? void 0 : _b.call(this, tag);
      var top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
      if (top === null) {
        this.closedRoot = true;
      }
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */
  }, {
    key: "closeTag",
    value: function closeTag() {
      var tags = this.tags,
        name = this.name;
      // Our state after this will be S_TEXT, no matter what, and we can clear
      // tagName now.
      this.state = S_TEXT;
      this.name = "";
      if (name === "") {
        this.fail("weird empty close tag.");
        this.text += "</>";
        return;
      }
      var handler = this.closeTagHandler;
      var l = tags.length;
      while (l-- > 0) {
        var tag = this.tag = tags.pop();
        this.topNS = tag.ns;
        // eslint-disable-next-line no-unused-expressions
        handler === null || handler === void 0 ? void 0 : handler(tag);
        if (tag.name === name) {
          break;
        }
        this.fail("unexpected close tag.");
      }
      if (l === 0) {
        this.closedRoot = true;
      } else if (l < 0) {
        this.fail("unmatched closing tag: ".concat(name, "."));
        this.text += "</".concat(name, ">");
      }
    }
    /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */
  }, {
    key: "parseEntity",
    value: function parseEntity(entity) {
      // startsWith would be significantly slower for this test.
      // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
      if (entity[0] !== "#") {
        var defined = this.ENTITIES[entity];
        if (defined !== undefined) {
          return defined;
        }
        this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
        return "&".concat(entity, ";");
      }
      var num = NaN;
      if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) {
        num = parseInt(entity.slice(2), 16);
      } else if (/^#[0-9]+$/.test(entity)) {
        num = parseInt(entity.slice(1), 10);
      }
      // The character reference is required to match the CHAR production.
      if (!this.isChar(num)) {
        this.fail("malformed character entity.");
        return "&".concat(entity, ";");
      }
      return String.fromCodePoint(num);
    }
  }]);
  return SaxesParser;
}();
exports.SaxesParser = SaxesParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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